"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ed5 = require("xmlchars/xml/1.0/ed5");
var ed2 = require("xmlchars/xml/1.1/ed2");
var NSed3 = require("xmlchars/xmlns/1.0/ed3");
var isS = ed5.isS;
var isChar10 = ed5.isChar;
var isNameStartChar = ed5.isNameStartChar;
var isNameChar = ed5.isNameChar;
var S_LIST = ed5.S_LIST;
var NAME_RE = ed5.NAME_RE;
var isChar11 = ed2.isChar;
var isNCNameStartChar = NSed3.isNCNameStartChar;
var isNCNameChar = NSed3.isNCNameChar;
var NC_NAME_RE = NSed3.NC_NAME_RE;
var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
var rootNS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  xml: XML_NAMESPACE,
  xmlns: XMLNS_NAMESPACE
};
var XML_ENTITIES = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  amp: "&",
  gt: ">",
  lt: "<",
  quot: "\"",
  apos: "'"
};
// EOC: end-of-chunk
var EOC = -1;
var NL_LIKE = -2;
var S_BEGIN = 0; // Initial state.
var S_BEGIN_WHITESPACE = 1; // leading whitespace
var S_DOCTYPE = 2; // <!DOCTYPE
var S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
var S_DTD = 4; // <!DOCTYPE "//blah" [ ...
var S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
var S_DTD_OPEN_WAKA = 6;
var S_DTD_OPEN_WAKA_BANG = 7;
var S_DTD_COMMENT = 8; // <!--
var S_DTD_COMMENT_ENDING = 9; // <!-- blah -
var S_DTD_COMMENT_ENDED = 10; // <!-- blah --
var S_DTD_PI = 11; // <?
var S_DTD_PI_ENDING = 12; // <?hi "there" ?
var S_TEXT = 13; // general stuff
var S_ENTITY = 14; // &amp and such
var S_OPEN_WAKA = 15; // <
var S_OPEN_WAKA_BANG = 16; // <!...
var S_COMMENT = 17; // <!--
var S_COMMENT_ENDING = 18; // <!-- blah -
var S_COMMENT_ENDED = 19; // <!-- blah --
var S_CDATA = 20; // <![CDATA[ something
var S_CDATA_ENDING = 21; // ]
var S_CDATA_ENDING_2 = 22; // ]]
var S_PI_FIRST_CHAR = 23; // <?hi, first char
var S_PI_REST = 24; // <?hi, rest of the name
var S_PI_BODY = 25; // <?hi there
var S_PI_ENDING = 26; // <?hi "there" ?
var S_XML_DECL_NAME_START = 27; // <?xml
var S_XML_DECL_NAME = 28; // <?xml foo
var S_XML_DECL_EQ = 29; // <?xml foo=
var S_XML_DECL_VALUE_START = 30; // <?xml foo=
var S_XML_DECL_VALUE = 31; // <?xml foo="bar"
var S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
var S_XML_DECL_ENDING = 33; // <?xml ... ?
var S_OPEN_TAG = 34; // <strong
var S_OPEN_TAG_SLASH = 35; // <strong /
var S_ATTRIB = 36; // <a
var S_ATTRIB_NAME = 37; // <a foo
var S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
var S_ATTRIB_VALUE = 39; // <a foo=
var S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
var S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
var S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
var S_CLOSE_TAG = 43; // </a
var S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
var BANG = 0x21;
var DQUOTE = 0x22;
var AMP = 0x26;
var SQUOTE = 0x27;
var MINUS = 0x2D;
var FORWARD_SLASH = 0x2F;
var SEMICOLON = 0x3B;
var LESS = 0x3C;
var EQUAL = 0x3D;
var GREATER = 0x3E;
var QUESTION = 0x3F;
var OPEN_BRACKET = 0x5B;
var CLOSE_BRACKET = 0x5D;
var NEL = 0x85;
var LS = 0x2028; // Line Separator
var isQuote = function isQuote(c) {
  return c === DQUOTE || c === SQUOTE;
};
var QUOTES = [DQUOTE, SQUOTE];
var DOCTYPE_TERMINATOR = [].concat(QUOTES, [OPEN_BRACKET, GREATER]);
var DTD_TERMINATOR = [].concat(QUOTES, [LESS, CLOSE_BRACKET]);
var XML_DECL_NAME_TERMINATOR = [EQUAL, QUESTION].concat(_toConsumableArray(S_LIST));
var ATTRIB_VALUE_UNQUOTED_TERMINATOR = [].concat(_toConsumableArray(S_LIST), [GREATER, AMP, LESS]);
function nsPairCheck(parser, prefix, uri) {
  switch (prefix) {
    case "xml":
      if (uri !== XML_NAMESPACE) {
        parser.fail("xml prefix must be bound to ".concat(XML_NAMESPACE, "."));
      }
      break;
    case "xmlns":
      if (uri !== XMLNS_NAMESPACE) {
        parser.fail("xmlns prefix must be bound to ".concat(XMLNS_NAMESPACE, "."));
      }
      break;
    default:
  }
  switch (uri) {
    case XMLNS_NAMESPACE:
      parser.fail(prefix === "" ? "the default namespace may not be set to ".concat(uri, ".") : "may not assign a prefix (even \"xmlns\") to the URI ".concat(XMLNS_NAMESPACE, "."));
      break;
    case XML_NAMESPACE:
      switch (prefix) {
        case "xml":
          // Assinging the XML namespace to "xml" is fine.
          break;
        case "":
          parser.fail("the default namespace may not be set to ".concat(uri, "."));
          break;
        default:
          parser.fail("may not assign the xml namespace to another prefix.");
      }
      break;
    default:
  }
}
function nsMappingCheck(parser, mapping) {
  for (var _i = 0, _Object$keys = Object.keys(mapping); _i < _Object$keys.length; _i++) {
    var local = _Object$keys[_i];
    nsPairCheck(parser, local, mapping[local]);
  }
}
var isNCName = function isNCName(name) {
  return NC_NAME_RE.test(name);
};
var isName = function isName(name) {
  return NAME_RE.test(name);
};
var FORBIDDEN_START = 0;
var FORBIDDEN_BRACKET = 1;
var FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */
exports.EVENTS = ["xmldecl", "text", "processinginstruction", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "cdata", "error", "end", "ready"];
var EVENT_NAME_TO_HANDLER_NAME = {
  xmldecl: "xmldeclHandler",
  text: "textHandler",
  processinginstruction: "piHandler",
  doctype: "doctypeHandler",
  comment: "commentHandler",
  opentagstart: "openTagStartHandler",
  attribute: "attributeHandler",
  opentag: "openTagHandler",
  closetag: "closeTagHandler",
  cdata: "cdataHandler",
  error: "errorHandler",
  end: "endHandler",
  ready: "readyHandler"
};
var SaxesParser = /*#__PURE__*/function () {
  /**
   * @param opt The parser options.
   */
  function SaxesParser(opt) {
    _classCallCheck(this, SaxesParser);
    this.opt = opt !== null && opt !== void 0 ? opt : {};
    this.fragmentOpt = !!this.opt.fragment;
    var xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
    this.trackPosition = this.opt.position !== false;
    this.fileName = this.opt.fileName;
    if (xmlnsOpt) {
      // This is the function we use to perform name checks on PIs and entities.
      // When namespaces are used, colons are not allowed in PI target names or
      // entity names. So the check depends on whether namespaces are used. See:
      //
      // https://www.w3.org/XML/xml-names-19990114-errata.html
      // NE08
      //
      this.nameStartCheck = isNCNameStartChar;
      this.nameCheck = isNCNameChar;
      this.isName = isNCName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsNS;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribNS;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.ns = Object.assign({
        __proto__: null
      }, rootNS);
      var additional = this.opt.additionalNamespaces;
      if (additional != null) {
        nsMappingCheck(this, additional);
        Object.assign(this.ns, additional);
      }
    } else {
      this.nameStartCheck = isNameStartChar;
      this.nameCheck = isNameChar;
      this.isName = isName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsPlain;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribPlain;
    }
    //
    // The order of the members in this table needs to correspond to the state
    // numbers given to the states that correspond to the methods being recorded
    // here.
    //
    this.stateTable = [/* eslint-disable @typescript-eslint/unbound-method */
    this.sBegin, this.sBeginWhitespace, this.sDoctype, this.sDoctypeQuote, this.sDTD, this.sDTDQuoted, this.sDTDOpenWaka, this.sDTDOpenWakaBang, this.sDTDComment, this.sDTDCommentEnding, this.sDTDCommentEnded, this.sDTDPI, this.sDTDPIEnding, this.sText, this.sEntity, this.sOpenWaka, this.sOpenWakaBang, this.sComment, this.sCommentEnding, this.sCommentEnded, this.sCData, this.sCDataEnding, this.sCDataEnding2, this.sPIFirstChar, this.sPIRest, this.sPIBody, this.sPIEnding, this.sXMLDeclNameStart, this.sXMLDeclName, this.sXMLDeclEq, this.sXMLDeclValueStart, this.sXMLDeclValue, this.sXMLDeclSeparator, this.sXMLDeclEnding, this.sOpenTag, this.sOpenTagSlash, this.sAttrib, this.sAttribName, this.sAttribNameSawWhite, this.sAttribValue, this.sAttribValueQuoted, this.sAttribValueClosed, this.sAttribValueUnquoted, this.sCloseTag, this.sCloseTagSawWhite];
    this._init();
  }
  /**
   * Indicates whether or not the parser is closed. If ``true``, wait for
   * the ``ready`` event to write again.
   */
  _createClass(SaxesParser, [{
    key: "closed",
    get: function get() {
      return this._closed;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _a;
      this.openWakaBang = "";
      this.text = "";
      this.name = "";
      this.piTarget = "";
      this.entity = "";
      this.q = null;
      this.tags = [];
      this.tag = null;
      this.topNS = null;
      this.chunk = "";
      this.chunkPosition = 0;
      this.i = 0;
      this.prevI = 0;
      this.carriedFromPrevious = undefined;
      this.forbiddenState = FORBIDDEN_START;
      this.attribList = [];
      // The logic is organized so as to minimize the need to check
      // this.opt.fragment while parsing.
      var fragmentOpt = this.fragmentOpt;
      this.state = fragmentOpt ? S_TEXT : S_BEGIN;
      // We want these to be all true if we are dealing with a fragment.
      this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
      // An XML declaration is intially possible only when parsing whole
      // documents.
      this.xmlDeclPossible = !fragmentOpt;
      this.xmlDeclExpects = ["version"];
      this.entityReturnState = undefined;
      var defaultXMLVersion = this.opt.defaultXMLVersion;
      if (defaultXMLVersion === undefined) {
        if (this.opt.forceXMLVersion === true) {
          throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
        }
        defaultXMLVersion = "1.0";
      }
      this.setXMLVersion(defaultXMLVersion);
      this.positionAtNewLine = 0;
      this.doctype = false;
      this._closed = false;
      this.xmlDecl = {
        version: undefined,
        encoding: undefined,
        standalone: undefined
      };
      this.line = 1;
      this.column = 0;
      this.ENTITIES = Object.create(XML_ENTITIES);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.readyHandler) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */
  }, {
    key: "position",
    get: function get() {
      return this.chunkPosition + this.i;
    }
    /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */
  }, {
    key: "columnIndex",
    get: function get() {
      return this.position - this.positionAtNewLine;
    }
    /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */
  }, {
    key: "on",
    value: function on(name, handler) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
    }
    /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */
  }, {
    key: "off",
    value: function off(name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
    }
    /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */
  }, {
    key: "makeError",
    value: function makeError(message) {
      var _a;
      var msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
      if (this.trackPosition) {
        if (msg.length > 0) {
          msg += ":";
        }
        msg += "".concat(this.line, ":").concat(this.column);
      }
      if (msg.length > 0) {
        msg += ": ";
      }
      return new Error(msg + message);
    }
    /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */
  }, {
    key: "fail",
    value: function fail(message) {
      var err = this.makeError(message);
      var handler = this.errorHandler;
      if (handler === undefined) {
        throw err;
      } else {
        handler(err);
      }
      return this;
    }
    /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */
  }, {
    key: "write",
    value: function write(chunk) {
      if (this.closed) {
        return this.fail("cannot write after close; assign an onready handler.");
      }
      var end = false;
      if (chunk === null) {
        // We cannot return immediately because carriedFromPrevious may need
        // processing.
        end = true;
        chunk = "";
      } else if (_typeof(chunk) === "object") {
        chunk = chunk.toString();
      }
      // We checked if performing a pre-decomposition of the string into an array
      // of single complete characters (``Array.from(chunk)``) would be faster
      // than the current repeated calls to ``charCodeAt``. As of August 2018, it
      // isn't. (There may be Node-specific code that would perform faster than
      // ``Array.from`` but don't want to be dependent on Node.)
      if (this.carriedFromPrevious !== undefined) {
        // The previous chunk had char we must carry over.
        chunk = "".concat(this.carriedFromPrevious).concat(chunk);
        this.carriedFromPrevious = undefined;
      }
      var limit = chunk.length;
      var lastCode = chunk.charCodeAt(limit - 1);
      if (!end && (
      // A trailing CR or surrogate must be carried over to the next
      // chunk.
      lastCode === CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
        // The chunk ends with a character that must be carried over. We cannot
        // know how to handle it until we get the next chunk or the end of the
        // stream. So save it for later.
        this.carriedFromPrevious = chunk[limit - 1];
        limit--;
        chunk = chunk.slice(0, limit);
      }
      var stateTable = this.stateTable;
      this.chunk = chunk;
      this.i = 0;
      while (this.i < limit) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        stateTable[this.state].call(this);
      }
      this.chunkPosition += limit;
      return end ? this.end() : this;
    }
    /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */
  }, {
    key: "close",
    value: function close() {
      return this.write(null);
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */
  }, {
    key: "getCode10",
    value: function getCode10() {
      var chunk = this.chunk,
        i = this.i;
      this.prevI = i;
      // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.
      this.i = i + 1;
      if (i >= chunk.length) {
        return EOC;
      }
      // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.
      var code = chunk.charCodeAt(i);
      this.column++;
      if (code < 0xD800) {
        if (code >= SPACE || code === TAB) {
          return code;
        }
        switch (code) {
          case NL:
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;
          case CR:
            // We may get NaN if we read past the end of the chunk, which is fine.
            if (chunk.charCodeAt(i + 1) === NL) {
              // A \r\n sequence is converted to \n so we have to skip over the
              // next character. We already know it has a size of 1 so ++ is fine
              // here.
              this.i = i + 2;
            }
            // Otherwise, a \r is just converted to \n, so we don't have to skip
            // ahead.
            // In either case, \r becomes \n.
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;
          default:
            // If we get here, then code < SPACE and it is not NL CR or TAB.
            this.fail("disallowed character.");
            return code;
        }
      }
      if (code > 0xDBFF) {
        // This is a specialized version of isChar10 that takes into account
        // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
        // test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }
        return code;
      }
      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2;
      // This is a specialized version of isChar10 that takes into account that in
      // this context necessarily final >= 0x10000.
      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }
      return final;
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */
  }, {
    key: "getCode11",
    value: function getCode11() {
      var chunk = this.chunk,
        i = this.i;
      this.prevI = i;
      // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.
      this.i = i + 1;
      if (i >= chunk.length) {
        return EOC;
      }
      // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.
      var code = chunk.charCodeAt(i);
      this.column++;
      if (code < 0xD800) {
        if (code > 0x1F && code < 0x7F || code > 0x9F && code !== LS || code === TAB) {
          return code;
        }
        switch (code) {
          case NL:
            // 0xA
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;
          case CR:
            {
              // 0xD
              // We may get NaN if we read past the end of the chunk, which is
              // fine.
              var next = chunk.charCodeAt(i + 1);
              if (next === NL || next === NEL) {
                // A CR NL or CR NEL sequence is converted to NL so we have to skip
                // over the next character. We already know it has a size of 1.
                this.i = i + 2;
              }
              // Otherwise, a CR is just converted to NL, no skip.
            }
          /* yes, fall through */
          case NEL: // 0x85
          case LS:
            // Ox2028
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;
          default:
            this.fail("disallowed character.");
            return code;
        }
      }
      if (code > 0xDBFF) {
        // This is a specialized version of isCharAndNotRestricted that takes into
        // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
        // does not test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }
        return code;
      }
      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2;
      // This is a specialized version of isCharAndNotRestricted that takes into
      // account that in this context necessarily final >= 0x10000.
      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }
      return final;
    }
    /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */
  }, {
    key: "getCodeNorm",
    value: function getCodeNorm() {
      var c = this.getCode();
      return c === NL_LIKE ? NL : c;
    }
  }, {
    key: "unget",
    value: function unget() {
      this.i = this.prevI;
      this.column--;
    }
    /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "captureTo",
    value: function captureTo(chars) {
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        var isNLLike = c === NL_LIKE;
        var final = isNLLike ? NL : c;
        if (final === EOC || chars.includes(final)) {
          this.text += chunk.slice(start, this.prevI);
          return final;
        }
        if (isNLLike) {
          this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          start = this.i;
        }
      }
    }
    /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */
  }, {
    key: "captureToChar",
    value: function captureToChar(char) {
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        switch (c) {
          case NL_LIKE:
            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            c = NL;
            break;
          case EOC:
            this.text += chunk.slice(start);
            return false;
          default:
        }
        if (c === char) {
          this.text += chunk.slice(start, this.prevI);
          return true;
        }
      }
    }
    /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "captureNameChars",
    value: function captureNameChars() {
      var chunk = this.chunk,
        start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        if (c === EOC) {
          this.name += chunk.slice(start);
          return EOC;
        }
        // NL is not a name char so we don't have to test specifically for it.
        if (!isNameChar(c)) {
          this.name += chunk.slice(start, this.prevI);
          return c === NL_LIKE ? NL : c;
        }
      }
    }
    /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "skipSpaces",
    value: function skipSpaces() {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();
        if (c === EOC || !isS(c)) {
          return c;
        }
      }
    }
  }, {
    key: "setXMLVersion",
    value: function setXMLVersion(version) {
      this.currentXMLVersion = version;
      /*  eslint-disable @typescript-eslint/unbound-method */
      if (version === "1.0") {
        this.isChar = isChar10;
        this.getCode = this.getCode10;
      } else {
        this.isChar = isChar11;
        this.getCode = this.getCode11;
      }
      /* eslint-enable @typescript-eslint/unbound-method */
    }
    // STATE ENGINE METHODS
    // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
    // to be sure never to come back to this state later.
  }, {
    key: "sBegin",
    value: function sBegin() {
      // We are essentially peeking at the first character of the chunk. Since
      // S_BEGIN can be in effect only when we start working on the first chunk,
      // the index at which we must look is necessarily 0. Note also that the
      // following test does not depend on decoding surrogates.
      // If the initial character is 0xFEFF, ignore it.
      if (this.chunk.charCodeAt(0) === 0xFEFF) {
        this.i++;
        this.column++;
      }
      this.state = S_BEGIN_WHITESPACE;
    }
  }, {
    key: "sBeginWhitespace",
    value: function sBeginWhitespace() {
      // We need to know whether we've encountered spaces or not because as soon
      // as we run into a space, an XML declaration is no longer possible. Rather
      // than slow down skipSpaces even in places where we don't care whether it
      // skipped anything or not, we check whether prevI is equal to the value of
      // i from before we skip spaces.
      var iBefore = this.i;
      var c = this.skipSpaces();
      if (this.prevI !== iBefore) {
        this.xmlDeclPossible = false;
      }
      switch (c) {
        case LESS:
          this.state = S_OPEN_WAKA;
          // We could naively call closeText but in this state, it is not normal
          // to have text be filled with any data.
          if (this.text.length !== 0) {
            throw new Error("no-empty text at start");
          }
          break;
        case EOC:
          break;
        default:
          this.unget();
          this.state = S_TEXT;
          this.xmlDeclPossible = false;
      }
    }
  }, {
    key: "sDoctype",
    value: function sDoctype() {
      var _a;
      var c = this.captureTo(DOCTYPE_TERMINATOR);
      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.doctypeHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            this.doctype = true; // just remember that we saw it.
            break;
          }
        case EOC:
          break;
        default:
          this.text += String.fromCodePoint(c);
          if (c === OPEN_BRACKET) {
            this.state = S_DTD;
          } else if (isQuote(c)) {
            this.state = S_DOCTYPE_QUOTE;
            this.q = c;
          }
      }
    }
  }, {
    key: "sDoctypeQuote",
    value: function sDoctypeQuote() {
      var q = this.q;
      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.q = null;
        this.state = S_DOCTYPE;
      }
    }
  }, {
    key: "sDTD",
    value: function sDTD() {
      var c = this.captureTo(DTD_TERMINATOR);
      if (c === EOC) {
        return;
      }
      this.text += String.fromCodePoint(c);
      if (c === CLOSE_BRACKET) {
        this.state = S_DOCTYPE;
      } else if (c === LESS) {
        this.state = S_DTD_OPEN_WAKA;
      } else if (isQuote(c)) {
        this.state = S_DTD_QUOTED;
        this.q = c;
      }
    }
  }, {
    key: "sDTDQuoted",
    value: function sDTDQuoted() {
      var q = this.q;
      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.state = S_DTD;
        this.q = null;
      }
    }
  }, {
    key: "sDTDOpenWaka",
    value: function sDTDOpenWaka() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      switch (c) {
        case BANG:
          this.state = S_DTD_OPEN_WAKA_BANG;
          this.openWakaBang = "";
          break;
        case QUESTION:
          this.state = S_DTD_PI;
          break;
        default:
          this.state = S_DTD;
      }
    }
  }, {
    key: "sDTDOpenWakaBang",
    value: function sDTDOpenWakaBang() {
      var char = String.fromCodePoint(this.getCodeNorm());
      var owb = this.openWakaBang += char;
      this.text += char;
      if (owb !== "-") {
        this.state = owb === "--" ? S_DTD_COMMENT : S_DTD;
        this.openWakaBang = "";
      }
    }
  }, {
    key: "sDTDComment",
    value: function sDTDComment() {
      if (this.captureToChar(MINUS)) {
        this.text += "-";
        this.state = S_DTD_COMMENT_ENDING;
      }
    }
  }, {
    key: "sDTDCommentEnding",
    value: function sDTDCommentEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      this.state = c === MINUS ? S_DTD_COMMENT_ENDED : S_DTD_COMMENT;
    }
  }, {
    key: "sDTDCommentEnded",
    value: function sDTDCommentEnded() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      if (c === GREATER) {
        this.state = S_DTD;
      } else {
        this.fail("malformed comment.");
        // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "
        this.state = S_DTD_COMMENT;
      }
    }
  }, {
    key: "sDTDPI",
    value: function sDTDPI() {
      if (this.captureToChar(QUESTION)) {
        this.text += "?";
        this.state = S_DTD_PI_ENDING;
      }
    }
  }, {
    key: "sDTDPIEnding",
    value: function sDTDPIEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      if (c === GREATER) {
        this.state = S_DTD;
      }
    }
  }, {
    key: "sText",
    value: function sText() {
      //
      // We did try a version of saxes where the S_TEXT state was split in two
      // states: one for text inside the root element, and one for text
      // outside. This was avoiding having to test this.tags.length to decide
      // what implementation to actually use.
      //
      // Peformance testing on gigabyte-size files did not show any advantage to
      // using the two states solution instead of the current one. Conversely, it
      // made the code a bit more complicated elsewhere. For instance, a comment
      // can appear before the root element so when a comment ended it was
      // necessary to determine whether to return to the S_TEXT state or to the
      // new text-outside-root state.
      //
      if (this.tags.length !== 0) {
        this.handleTextInRoot();
      } else {
        this.handleTextOutsideRoot();
      }
    }
  }, {
    key: "sEntity",
    value: function sEntity() {
      // This is essentially a specialized version of captureToChar(SEMICOLON...)
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      loop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case NL_LIKE:
            this.entity += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            break;
          case SEMICOLON:
            {
              var entityReturnState = this.entityReturnState;
              var entity = this.entity + chunk.slice(start, this.prevI);
              this.state = entityReturnState;
              var parsed = void 0;
              if (entity === "") {
                this.fail("empty entity name.");
                parsed = "&;";
              } else {
                parsed = this.parseEntity(entity);
                this.entity = "";
              }
              if (entityReturnState !== S_TEXT || this.textHandler !== undefined) {
                this.text += parsed;
              }
              // eslint-disable-next-line no-labels
              break loop;
            }
          case EOC:
            this.entity += chunk.slice(start);
            // eslint-disable-next-line no-labels
            break loop;
          default:
        }
      }
    }
  }, {
    key: "sOpenWaka",
    value: function sOpenWaka() {
      // Reminder: a state handler is called with at least one character
      // available in the current chunk. So the first call to get code inside of
      // a state handler cannot return ``EOC``. That's why we don't test
      // for it.
      var c = this.getCode();
      // either a /, ?, !, or text is coming next.
      if (isNameStartChar(c)) {
        this.state = S_OPEN_TAG;
        this.unget();
        this.xmlDeclPossible = false;
      } else {
        switch (c) {
          case FORWARD_SLASH:
            this.state = S_CLOSE_TAG;
            this.xmlDeclPossible = false;
            break;
          case BANG:
            this.state = S_OPEN_WAKA_BANG;
            this.openWakaBang = "";
            this.xmlDeclPossible = false;
            break;
          case QUESTION:
            this.state = S_PI_FIRST_CHAR;
            break;
          default:
            this.fail("disallowed character in tag name");
            this.state = S_TEXT;
            this.xmlDeclPossible = false;
        }
      }
    }
  }, {
    key: "sOpenWakaBang",
    value: function sOpenWakaBang() {
      this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
      switch (this.openWakaBang) {
        case "[CDATA[":
          if (!this.sawRoot && !this.reportedTextBeforeRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextBeforeRoot = true;
          }
          if (this.closedRoot && !this.reportedTextAfterRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextAfterRoot = true;
          }
          this.state = S_CDATA;
          this.openWakaBang = "";
          break;
        case "--":
          this.state = S_COMMENT;
          this.openWakaBang = "";
          break;
        case "DOCTYPE":
          this.state = S_DOCTYPE;
          if (this.doctype || this.sawRoot) {
            this.fail("inappropriately located doctype declaration.");
          }
          this.openWakaBang = "";
          break;
        default:
          // 7 happens to be the maximum length of the string that can possibly
          // match one of the cases above.
          if (this.openWakaBang.length >= 7) {
            this.fail("incorrect syntax.");
          }
      }
    }
  }, {
    key: "sComment",
    value: function sComment() {
      if (this.captureToChar(MINUS)) {
        this.state = S_COMMENT_ENDING;
      }
    }
  }, {
    key: "sCommentEnding",
    value: function sCommentEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === MINUS) {
        this.state = S_COMMENT_ENDED;
        // eslint-disable-next-line no-unused-expressions
        (_a = this.commentHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
        this.text = "";
      } else {
        this.text += "-".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      }
    }
  }, {
    key: "sCommentEnded",
    value: function sCommentEnded() {
      var c = this.getCodeNorm();
      if (c !== GREATER) {
        this.fail("malformed comment.");
        // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "
        this.text += "--".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      } else {
        this.state = S_TEXT;
      }
    }
  }, {
    key: "sCData",
    value: function sCData() {
      if (this.captureToChar(CLOSE_BRACKET)) {
        this.state = S_CDATA_ENDING;
      }
    }
  }, {
    key: "sCDataEnding",
    value: function sCDataEnding() {
      var c = this.getCodeNorm();
      if (c === CLOSE_BRACKET) {
        this.state = S_CDATA_ENDING_2;
      } else {
        this.text += "]".concat(String.fromCodePoint(c));
        this.state = S_CDATA;
      }
    }
  }, {
    key: "sCDataEnding2",
    value: function sCDataEnding2() {
      var _a;
      var c = this.getCodeNorm();
      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.cdataHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            break;
          }
        case CLOSE_BRACKET:
          this.text += "]";
          break;
        default:
          this.text += "]]".concat(String.fromCodePoint(c));
          this.state = S_CDATA;
      }
    }
    // We need this separate state to check the first character fo the pi target
    // with this.nameStartCheck which allows less characters than this.nameCheck.
  }, {
    key: "sPIFirstChar",
    value: function sPIFirstChar() {
      var c = this.getCodeNorm();
      // This is first because in the case where the file is well-formed this is
      // the branch taken. We optimize for well-formedness.
      if (this.nameStartCheck(c)) {
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      } else if (c === QUESTION || isS(c)) {
        this.fail("processing instruction without a target.");
        this.state = c === QUESTION ? S_PI_ENDING : S_PI_BODY;
      } else {
        this.fail("disallowed character in processing instruction name.");
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      }
    }
  }, {
    key: "sPIRest",
    value: function sPIRest() {
      // Capture characters into a piTarget while ``this.nameCheck`` run on the
      // character read returns true.
      var chunk = this.chunk,
        start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();
        if (c === EOC) {
          this.piTarget += chunk.slice(start);
          return;
        }
        // NL cannot satisfy this.nameCheck so we don't have to test specifically
        // for it.
        if (!this.nameCheck(c)) {
          this.piTarget += chunk.slice(start, this.prevI);
          var isQuestion = c === QUESTION;
          if (isQuestion || isS(c)) {
            if (this.piTarget === "xml") {
              if (!this.xmlDeclPossible) {
                this.fail("an XML declaration must be at the start of the document.");
              }
              this.state = isQuestion ? S_XML_DECL_ENDING : S_XML_DECL_NAME_START;
            } else {
              this.state = isQuestion ? S_PI_ENDING : S_PI_BODY;
            }
          } else {
            this.fail("disallowed character in processing instruction name.");
            this.piTarget += String.fromCodePoint(c);
          }
          break;
        }
      }
    }
  }, {
    key: "sPIBody",
    value: function sPIBody() {
      if (this.text.length === 0) {
        var c = this.getCodeNorm();
        if (c === QUESTION) {
          this.state = S_PI_ENDING;
        } else if (!isS(c)) {
          this.text = String.fromCodePoint(c);
        }
      }
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      else if (this.captureToChar(QUESTION)) {
        this.state = S_PI_ENDING;
      }
    }
  }, {
    key: "sPIEnding",
    value: function sPIEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === GREATER) {
        var piTarget = this.piTarget;
        if (piTarget.toLowerCase() === "xml") {
          this.fail("the XML declaration must appear at the start of the document.");
        }
        // eslint-disable-next-line no-unused-expressions
        (_a = this.piHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
          target: piTarget,
          body: this.text
        });
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else if (c === QUESTION) {
        // We ran into ?? as part of a processing instruction. We initially took
        // the first ? as a sign that the PI was ending, but it is not. So we have
        // to add it to the body but we take the new ? as a sign that the PI is
        // ending.
        this.text += "?";
      } else {
        this.text += "?".concat(String.fromCodePoint(c));
        this.state = S_PI_BODY;
      }
      this.xmlDeclPossible = false;
    }
  }, {
    key: "sXMLDeclNameStart",
    value: function sXMLDeclNameStart() {
      var c = this.skipSpaces();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }
      if (c !== EOC) {
        this.state = S_XML_DECL_NAME;
        this.name = String.fromCodePoint(c);
      }
    }
  }, {
    key: "sXMLDeclName",
    value: function sXMLDeclName() {
      var c = this.captureTo(XML_DECL_NAME_TERMINATOR);
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.name += this.text;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (!(isS(c) || c === EQUAL)) {
        return;
      }
      this.name += this.text;
      this.text = "";
      if (!this.xmlDeclExpects.includes(this.name)) {
        switch (this.name.length) {
          case 0:
            this.fail("did not expect any more name/value pairs.");
            break;
          case 1:
            this.fail("expected the name ".concat(this.xmlDeclExpects[0], "."));
            break;
          default:
            this.fail("expected one of ".concat(this.xmlDeclExpects.join(", ")));
        }
      }
      this.state = c === EQUAL ? S_XML_DECL_VALUE_START : S_XML_DECL_EQ;
    }
  }, {
    key: "sXMLDeclEq",
    value: function sXMLDeclEq() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (isS(c)) {
        return;
      }
      if (c !== EQUAL) {
        this.fail("value required.");
      }
      this.state = S_XML_DECL_VALUE_START;
    }
  }, {
    key: "sXMLDeclValueStart",
    value: function sXMLDeclValueStart() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (isS(c)) {
        return;
      }
      if (!isQuote(c)) {
        this.fail("value must be quoted.");
        this.q = SPACE;
      } else {
        this.q = c;
      }
      this.state = S_XML_DECL_VALUE;
    }
  }, {
    key: "sXMLDeclValue",
    value: function sXMLDeclValue() {
      var c = this.captureTo([this.q, QUESTION]);
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (c === EOC) {
        return;
      }
      var value = this.text;
      this.text = "";
      switch (this.name) {
        case "version":
          {
            this.xmlDeclExpects = ["encoding", "standalone"];
            var version = value;
            this.xmlDecl.version = version;
            // This is the test specified by XML 1.0 but it is fine for XML 1.1.
            if (!/^1\.[0-9]+$/.test(version)) {
              this.fail("version number must match /^1\\.[0-9]+$/.");
            }
            // When forceXMLVersion is set, the XML declaration is ignored.
            else if (!this.opt.forceXMLVersion) {
              this.setXMLVersion(version);
            }
            break;
          }
        case "encoding":
          if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) {
            this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
          }
          this.xmlDeclExpects = ["standalone"];
          this.xmlDecl.encoding = value;
          break;
        case "standalone":
          if (value !== "yes" && value !== "no") {
            this.fail("standalone value must match \"yes\" or \"no\".");
          }
          this.xmlDeclExpects = [];
          this.xmlDecl.standalone = value;
          break;
        default:
        // We don't need to raise an error here since we've already raised one
        // when checking what name was expected.
      }

      this.name = "";
      this.state = S_XML_DECL_SEPARATOR;
    }
  }, {
    key: "sXMLDeclSeparator",
    value: function sXMLDeclSeparator() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }
      if (!isS(c)) {
        this.fail("whitespace required.");
        this.unget();
      }
      this.state = S_XML_DECL_NAME_START;
    }
  }, {
    key: "sXMLDeclEnding",
    value: function sXMLDeclEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === GREATER) {
        if (this.piTarget !== "xml") {
          this.fail("processing instructions are not allowed before root.");
        } else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) {
          this.fail("XML declaration must contain a version.");
        }
        // eslint-disable-next-line no-unused-expressions
        (_a = this.xmldeclHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.xmlDecl);
        this.name = "";
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else {
        // We got here because the previous character was a ?, but the question
        // mark character is not valid inside any of the XML declaration
        // name/value pairs.
        this.fail("The character ? is disallowed anywhere in XML declarations.");
      }
      this.xmlDeclPossible = false;
    }
  }, {
    key: "sOpenTag",
    value: function sOpenTag() {
      var _a;
      var c = this.captureNameChars();
      if (c === EOC) {
        return;
      }
      var tag = this.tag = {
        name: this.name,
        attributes: Object.create(null)
      };
      this.name = "";
      if (this.xmlnsOpt) {
        this.topNS = tag.ns = Object.create(null);
      }
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagStartHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      this.sawRoot = true;
      if (!this.fragmentOpt && this.closedRoot) {
        this.fail("documents may contain only one root.");
      }
      switch (c) {
        case GREATER:
          this.openTag();
          break;
        case FORWARD_SLASH:
          this.state = S_OPEN_TAG_SLASH;
          break;
        default:
          if (!isS(c)) {
            this.fail("disallowed character in tag name.");
          }
          this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sOpenTagSlash",
    value: function sOpenTagSlash() {
      if (this.getCode() === GREATER) {
        this.openSelfClosingTag();
      } else {
        this.fail("forward-slash in opening tag not followed by >.");
        this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sAttrib",
    value: function sAttrib() {
      var c = this.skipSpaces();
      if (c === EOC) {
        return;
      }
      if (isNameStartChar(c)) {
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribName",
    value: function sAttribName() {
      var c = this.captureNameChars();
      if (c === EQUAL) {
        this.state = S_ATTRIB_VALUE;
      } else if (isS(c)) {
        this.state = S_ATTRIB_NAME_SAW_WHITE;
      } else if (c === GREATER) {
        this.fail("attribute without value.");
        this.pushAttrib(this.name, this.name);
        this.name = this.text = "";
        this.openTag();
      } else if (c !== EOC) {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribNameSawWhite",
    value: function sAttribNameSawWhite() {
      var c = this.skipSpaces();
      switch (c) {
        case EOC:
          return;
        case EQUAL:
          this.state = S_ATTRIB_VALUE;
          break;
        default:
          this.fail("attribute without value.");
          // Should we do this???
          // this.tag.attributes[this.name] = "";
          this.text = "";
          this.name = "";
          if (c === GREATER) {
            this.openTag();
          } else if (isNameStartChar(c)) {
            this.unget();
            this.state = S_ATTRIB_NAME;
          } else {
            this.fail("disallowed character in attribute name.");
            this.state = S_ATTRIB;
          }
      }
    }
  }, {
    key: "sAttribValue",
    value: function sAttribValue() {
      var c = this.getCodeNorm();
      if (isQuote(c)) {
        this.q = c;
        this.state = S_ATTRIB_VALUE_QUOTED;
      } else if (!isS(c)) {
        this.fail("unquoted attribute value.");
        this.state = S_ATTRIB_VALUE_UNQUOTED;
        this.unget();
      }
    }
  }, {
    key: "sAttribValueQuoted",
    value: function sAttribValueQuoted() {
      // We deliberately do not use captureTo here. The specialized code we use
      // here is faster than using captureTo.
      var q = this.q,
        chunk = this.chunk;
      var start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case q:
            this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
            this.name = this.text = "";
            this.q = null;
            this.state = S_ATTRIB_VALUE_CLOSED;
            return;
          case AMP:
            this.text += chunk.slice(start, this.prevI);
            this.state = S_ENTITY;
            this.entityReturnState = S_ATTRIB_VALUE_QUOTED;
            return;
          case NL:
          case NL_LIKE:
          case TAB:
            this.text += "".concat(chunk.slice(start, this.prevI), " ");
            start = this.i;
            break;
          case LESS:
            this.text += chunk.slice(start, this.prevI);
            this.fail("disallowed character.");
            return;
          case EOC:
            this.text += chunk.slice(start);
            return;
          default:
        }
      }
    }
  }, {
    key: "sAttribValueClosed",
    value: function sAttribValueClosed() {
      var c = this.getCodeNorm();
      if (isS(c)) {
        this.state = S_ATTRIB;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else if (isNameStartChar(c)) {
        this.fail("no whitespace between attributes.");
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribValueUnquoted",
    value: function sAttribValueUnquoted() {
      // We don't do anything regarding EOL or space handling for unquoted
      // attributes. We already have failed by the time we get here, and the
      // contract that saxes upholds states that upon failure, it is not safe to
      // rely on the data passed to event handlers (other than
      // ``onerror``). Passing "bad" data is not a problem.
      var c = this.captureTo(ATTRIB_VALUE_UNQUOTED_TERMINATOR);
      switch (c) {
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_ATTRIB_VALUE_UNQUOTED;
          break;
        case LESS:
          this.fail("disallowed character.");
          break;
        case EOC:
          break;
        default:
          if (this.text.includes("]]>")) {
            this.fail("the string \"]]>\" is disallowed in char data.");
          }
          this.pushAttrib(this.name, this.text);
          this.name = this.text = "";
          if (c === GREATER) {
            this.openTag();
          } else {
            this.state = S_ATTRIB;
          }
      }
    }
  }, {
    key: "sCloseTag",
    value: function sCloseTag() {
      var c = this.captureNameChars();
      if (c === GREATER) {
        this.closeTag();
      } else if (isS(c)) {
        this.state = S_CLOSE_TAG_SAW_WHITE;
      } else if (c !== EOC) {
        this.fail("disallowed character in closing tag.");
      }
    }
  }, {
    key: "sCloseTagSawWhite",
    value: function sCloseTagSawWhite() {
      switch (this.skipSpaces()) {
        case GREATER:
          this.closeTag();
          break;
        case EOC:
          break;
        default:
          this.fail("disallowed character in closing tag.");
      }
    }
    // END OF STATE ENGINE METHODS
  }, {
    key: "handleTextInRoot",
    value: function handleTextInRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for performing the ]]> check. A previous version of this code, checked
      // ``this.text`` for the presence of ]]>. It simplified the code but was
      // very costly when character data contained a lot of entities to be parsed.
      //
      // Since we are using a specialized loop, we also keep track of the presence
      // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
      //
      var start = this.i,
        forbiddenState = this.forbiddenState;
      var chunk = this.chunk,
        handler = this.textHandler;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      scanLoop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;
              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);
                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }
              forbiddenState = FORBIDDEN_START;
              // eslint-disable-next-line no-labels
              break scanLoop;
            }
          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;
            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }
            forbiddenState = FORBIDDEN_START;
            // eslint-disable-next-line no-labels
            break scanLoop;
          case CLOSE_BRACKET:
            switch (forbiddenState) {
              case FORBIDDEN_START:
                forbiddenState = FORBIDDEN_BRACKET;
                break;
              case FORBIDDEN_BRACKET:
                forbiddenState = FORBIDDEN_BRACKET_BRACKET;
                break;
              case FORBIDDEN_BRACKET_BRACKET:
                break;
              default:
                throw new Error("impossible state");
            }
            break;
          case GREATER:
            if (forbiddenState === FORBIDDEN_BRACKET_BRACKET) {
              this.fail("the string \"]]>\" is disallowed in char data.");
            }
            forbiddenState = FORBIDDEN_START;
            break;
          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }
            start = this.i;
            forbiddenState = FORBIDDEN_START;
            break;
          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            }
            // eslint-disable-next-line no-labels
            break scanLoop;
          default:
            forbiddenState = FORBIDDEN_START;
        }
      }
      this.forbiddenState = forbiddenState;
    }
  }, {
    key: "handleTextOutsideRoot",
    value: function handleTextOutsideRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for a specialized task. We keep track of the presence of non-space
      // characters in the text since these are errors when appearing outside the
      // document root element.
      var start = this.i;
      var chunk = this.chunk,
        handler = this.textHandler;
      var nonSpace = false;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      outRootLoop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var code = this.getCode();
        switch (code) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;
              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);
                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }
              // eslint-disable-next-line no-labels
              break outRootLoop;
            }
          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;
            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }
            nonSpace = true;
            // eslint-disable-next-line no-labels
            break outRootLoop;
          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }
            start = this.i;
            break;
          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            }
            // eslint-disable-next-line no-labels
            break outRootLoop;
          default:
            if (!isS(code)) {
              nonSpace = true;
            }
        }
      }
      if (!nonSpace) {
        return;
      }
      // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
      // to avoid reporting errors for every single character that is out of
      // place.
      if (!this.sawRoot && !this.reportedTextBeforeRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextBeforeRoot = true;
      }
      if (this.closedRoot && !this.reportedTextAfterRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextAfterRoot = true;
      }
    }
  }, {
    key: "pushAttribNS",
    value: function pushAttribNS(name, value) {
      var _a;
      var _this$qname = this.qname(name),
        prefix = _this$qname.prefix,
        local = _this$qname.local;
      var attr = {
        name: name,
        prefix: prefix,
        local: local,
        value: value
      };
      this.attribList.push(attr);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
      if (prefix === "xmlns") {
        var trimmed = value.trim();
        if (this.currentXMLVersion === "1.0" && trimmed === "") {
          this.fail("invalid attempt to undefine prefix in XML 1.0");
        }
        this.topNS[local] = trimmed;
        nsPairCheck(this, local, trimmed);
      } else if (name === "xmlns") {
        var _trimmed = value.trim();
        this.topNS[""] = _trimmed;
        nsPairCheck(this, "", _trimmed);
      }
    }
  }, {
    key: "pushAttribPlain",
    value: function pushAttribPlain(name, value) {
      var _a;
      var attr = {
        name: name,
        value: value
      };
      this.attribList.push(attr);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
    }
    /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */
  }, {
    key: "end",
    value: function end() {
      var _a, _b;
      if (!this.sawRoot) {
        this.fail("document must contain a root element.");
      }
      var tags = this.tags;
      while (tags.length > 0) {
        var tag = tags.pop();
        this.fail("unclosed tag: ".concat(tag.name));
      }
      if (this.state !== S_BEGIN && this.state !== S_TEXT) {
        this.fail("unexpected end.");
      }
      var text = this.text;
      if (text.length !== 0) {
        // eslint-disable-next-line no-unused-expressions
        (_a = this.textHandler) === null || _a === void 0 ? void 0 : _a.call(this, text);
        this.text = "";
      }
      this._closed = true;
      // eslint-disable-next-line no-unused-expressions
      (_b = this.endHandler) === null || _b === void 0 ? void 0 : _b.call(this);
      this._init();
      return this;
    }
    /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */
  }, {
    key: "resolve",
    value: function resolve(prefix) {
      var _a, _b;
      var uri = this.topNS[prefix];
      if (uri !== undefined) {
        return uri;
      }
      var tags = this.tags;
      for (var index = tags.length - 1; index >= 0; index--) {
        uri = tags[index].ns[prefix];
        if (uri !== undefined) {
          return uri;
        }
      }
      uri = this.ns[prefix];
      if (uri !== undefined) {
        return uri;
      }
      return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
    }
    /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */
  }, {
    key: "qname",
    value: function qname(name) {
      // This is faster than using name.split(":").
      var colon = name.indexOf(":");
      if (colon === -1) {
        return {
          prefix: "",
          local: name
        };
      }
      var local = name.slice(colon + 1);
      var prefix = name.slice(0, colon);
      if (prefix === "" || local === "" || local.includes(":")) {
        this.fail("malformed name: ".concat(name, "."));
      }
      return {
        prefix: prefix,
        local: local
      };
    }
  }, {
    key: "processAttribsNS",
    value: function processAttribsNS() {
      var _a;
      var attribList = this.attribList;
      var tag = this.tag;
      {
        // add namespace info to tag
        var _this$qname2 = this.qname(tag.name),
          prefix = _this$qname2.prefix,
          local = _this$qname2.local;
        tag.prefix = prefix;
        tag.local = local;
        var uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
        if (prefix !== "") {
          if (prefix === "xmlns") {
            this.fail("tags may not have \"xmlns\" as prefix.");
          }
          if (uri === "") {
            this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
            tag.uri = prefix;
          }
        }
      }
      if (attribList.length === 0) {
        return;
      }
      var attributes = tag.attributes;
      var seen = new Set();
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      var _iterator = _createForOfIteratorHelper(attribList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          var name = attr.name,
            _prefix = attr.prefix,
            _local = attr.local;
          var _uri = void 0;
          var eqname = void 0;
          if (_prefix === "") {
            _uri = name === "xmlns" ? XMLNS_NAMESPACE : "";
            eqname = name;
          } else {
            _uri = this.resolve(_prefix);
            // if there's any attributes with an undefined namespace,
            // then fail on them now.
            if (_uri === undefined) {
              this.fail("unbound namespace prefix: ".concat(JSON.stringify(_prefix), "."));
              _uri = _prefix;
            }
            eqname = "{".concat(_uri, "}").concat(_local);
          }
          if (seen.has(eqname)) {
            this.fail("duplicate attribute: ".concat(eqname, "."));
          }
          seen.add(eqname);
          attr.uri = _uri;
          attributes[name] = attr;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.attribList = [];
    }
  }, {
    key: "processAttribsPlain",
    value: function processAttribsPlain() {
      var attribList = this.attribList;
      // eslint-disable-next-line prefer-destructuring
      var attributes = this.tag.attributes;
      var _iterator2 = _createForOfIteratorHelper(attribList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
            name = _step2$value.name,
            value = _step2$value.value;
          if (attributes[name] !== undefined) {
            this.fail("duplicate attribute: ".concat(name, "."));
          }
          attributes[name] = value;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.attribList = [];
    }
    /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */
  }, {
    key: "openTag",
    value: function openTag() {
      var _a;
      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = false;
      // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      tags.push(tag);
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */
  }, {
    key: "openSelfClosingTag",
    value: function openSelfClosingTag() {
      var _a, _b, _c;
      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = true;
      // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      // eslint-disable-next-line no-unused-expressions
      (_b = this.closeTagHandler) === null || _b === void 0 ? void 0 : _b.call(this, tag);
      var top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
      if (top === null) {
        this.closedRoot = true;
      }
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */
  }, {
    key: "closeTag",
    value: function closeTag() {
      var tags = this.tags,
        name = this.name;
      // Our state after this will be S_TEXT, no matter what, and we can clear
      // tagName now.
      this.state = S_TEXT;
      this.name = "";
      if (name === "") {
        this.fail("weird empty close tag.");
        this.text += "</>";
        return;
      }
      var handler = this.closeTagHandler;
      var l = tags.length;
      while (l-- > 0) {
        var tag = this.tag = tags.pop();
        this.topNS = tag.ns;
        // eslint-disable-next-line no-unused-expressions
        handler === null || handler === void 0 ? void 0 : handler(tag);
        if (tag.name === name) {
          break;
        }
        this.fail("unexpected close tag.");
      }
      if (l === 0) {
        this.closedRoot = true;
      } else if (l < 0) {
        this.fail("unmatched closing tag: ".concat(name, "."));
        this.text += "</".concat(name, ">");
      }
    }
    /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */
  }, {
    key: "parseEntity",
    value: function parseEntity(entity) {
      // startsWith would be significantly slower for this test.
      // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
      if (entity[0] !== "#") {
        var defined = this.ENTITIES[entity];
        if (defined !== undefined) {
          return defined;
        }
        this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
        return "&".concat(entity, ";");
      }
      var num = NaN;
      if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) {
        num = parseInt(entity.slice(2), 16);
      } else if (/^#[0-9]+$/.test(entity)) {
        num = parseInt(entity.slice(1), 10);
      }
      // The character reference is required to match the CHAR production.
      if (!this.isChar(num)) {
        this.fail("malformed character entity.");
        return "&".concat(entity, ";");
      }
      return String.fromCodePoint(num);
    }
  }]);
  return SaxesParser;
}();
exports.SaxesParser = SaxesParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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